<template>
  <!-- eslint-disable max-len -->
  <div class="modal">
    <div class="modal__container">
      <h1 class="modal__header">Request Sent</h1>
      <v-form v-on:submit.prevent v-model="valid" ref="form">
        <div class="modal__inputs-container">
          <p
            class="modal__text"
          >If the provided email addresses matches an account's email address, you'll receive an email with the password reset link</p>
        </div>
        <div class="modal__footer">
          <div class="modal__footer-content">
            <div class="modal-btn__container">
              <v-btn
                class="elevation-0 modal-btn confirm"
                id="cancel"
                :color="'#CB201F'"
                @click="close()"
              >OK</v-btn>
            </div>
          </div>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Password-Reset-Confirm-Modal',
  props: ['active', 'modalType'],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 100; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */

  display: flex;
  justify-content: center;
  align-items: center;

  &__container {
    border-radius: 4px;
    padding: 30px 30px 20px 30px;
    background: #fff;
    color: #000;
    width: 400px;
  }

  &__btns {
    width: 100%;
  }

  h1,
  h2,
  p {
    color: #212121 !important;
    font-family: Heebo;
    line-height: 2.1rem;
    letter-spacing: 0.124rem;
    text-align: center;
  }

  &__header {
    font-size: 2.4rem !important;
    font-weight: bold;
    text-align: center;
    padding: 8px 0.5rem 30px 0.5rem !important;
  }

  &__text {
    text-align: center;
    padding: 0 0 1rem 0;
    font-size: 1.2rem;
  }

  &__inputs {
    height: 39px;
    width: 100%;
    border: 1px solid #dedede;
    border-radius: 6px;
    font-family: Heebo;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    padding-left: 10px;
    margin-bottom: 20px;

    &::placeholder {
      color: #dedede;
    }

    &:last-of-type {
      margin-bottom: initial;
    }

    &-header {
      font-size: 12px;
      padding-bottom: 5px;
      text-align: left !important;
    }
  }

  &__footer {
    width: 100%;
    display: flex;
    align-items: flex-end;

    &-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}

.modal-btn {
  font-family: Heebo !important;
  letter-spacing: 0.5px;
  font-size: 1.5rem !important;
  line-height: 24px;
  text-align: center;
  text-transform: none;
  width: 120px;

  &__container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 30px 5px 30px;

    #confirm,
    #cancel {
      font-family: Heebo !important;
      letter-spacing: 0.5px;
      font-size: 1.5rem !important;
      line-height: 24px;
      text-align: center;
      text-transform: none;
      width: 120px;
    }

    #confirm {
      color: #fff;
    }
  }

  &.confirm {
    color: #fff;
  }
}
</style>

